/**
 * Constants for social media platforms
 */

// Platform identifiers
export const FACEBOOK = 'facebook'
export const INSTAGRAM = 'instagram'
export const LINKEDIN = 'linkedin'
export const X = 'x'
export const YOUTUBE = 'youtube'
export const WHATSAPP = 'whatsapp'
export const WEBSITE = 'website'
export const OTHER = 'other'

// Display names
export const FACEBOOK_DISPLAY = 'Facebook'
export const INSTAGRAM_DISPLAY = 'Instagram'
export const LINKEDIN_DISPLAY = 'LinkedIn'
export const X_DISPLAY = 'X'
export const YOUTUBE_DISPLAY = 'YouTube'
export const WHATSAPP_DISPLAY = 'WhatsApp'
export const WEBSITE_DISPLAY = 'Personal Website'
export const OTHER_DISPLAY = 'Other'

// Icon names (Material Design Icons)
export const FACEBOOK_ICON = 'mdi-facebook'
export const INSTAGRAM_ICON = 'mdi-instagram'
export const LINKEDIN_ICON = 'mdi-linkedin'
export const X_ICON = 'mdi-alpha-x-circle'
export const YOUTUBE_ICON = 'mdi-youtube'
export const WHATSAPP_ICON = 'mdi-whatsapp'
export const WEBSITE_ICON = 'mdi-web'
export const OTHER_ICON = 'mdi-link'

// Brand colors
export const FACEBOOK_COLOR = '#1877F2'
export const INSTAGRAM_COLOR = '#E4405F'
export const LINKEDIN_COLOR = '#0A66C2'
export const X_COLOR = '#000'
export const YOUTUBE_COLOR = '#FF0000'
export const WHATSAPP_COLOR = '#25D366'
export const WEBSITE_COLOR = '#6366F1'
export const OTHER_COLOR = '#6B7280'

// URL patterns for detection
export const FACEBOOK_URL_PATTERN = 'facebook.com'
export const FACEBOOK_URL_PATTERN_ALT = 'fb.com'
export const INSTAGRAM_URL_PATTERN = 'instagram.com'
export const INSTAGRAM_URL_PATTERN_ALT = 'ig.com'
export const LINKEDIN_URL_PATTERN = 'linkedin.com'
export const LINKEDIN_URL_PATTERN_ALT = 'lnkd.in'
export const X_URL_PATTERN = 'x.com'
export const YOUTUBE_URL_PATTERN = 'youtube.com'
export const YOUTUBE_URL_PATTERN_ALT = 'youtu.be'
export const WHATSAPP_URL_PATTERN = 'wa.me'
export const WHATSAPP_URL_PATTERN_ALT = 'whatsapp.com'

// Supported platforms array
export const SUPPORTED_PLATFORMS = [
  FACEBOOK, INSTAGRAM, LINKEDIN, X, YOUTUBE, 
  WHATSAPP, WEBSITE, OTHER
]

// Platform options for UI components
export const PLATFORM_OPTIONS = [
  { text: FACEBOOK_DISPLAY, value: FACEBOOK },
  { text: INSTAGRAM_DISPLAY, value: INSTAGRAM },
  { text: LINKEDIN_DISPLAY, value: LINKEDIN },
  { text: X_DISPLAY, value: X },
  { text: YOUTUBE_DISPLAY, value: YOUTUBE },
  { text: WHATSAPP_DISPLAY, value: WHATSAPP },
  { text: WEBSITE_DISPLAY, value: WEBSITE },
  { text: OTHER_DISPLAY, value: OTHER }
]
